import type { FC, ReactNode } from "react";

import { Text, Heading, Row, Column, ButtonGroup } from "@hightouch/htui";
import { SplashLogos } from "./logos";
import { Page } from "src/components/layout";

type SplashComponentProps = {
  eyebrow: string;
  heading: string;
  description: ReactNode;
  actions: ReactNode;
  visual: ReactNode;
  hideLogos?: boolean;
  logoHeader?: string;
  infoSection?: ReactNode;
};

export const SplashPage: FC<Readonly<SplashComponentProps>> = (props) => {
  return (
    <Page title={props.eyebrow}>
      <Column
        maxWidth="1200px"
        px={{ base: 6, md: 9, lg: 16, xl: 24 }}
        height="100%"
        mt="64px"
        alignSelf="center"
      >
        <SplashComponent {...props} />
      </Column>
    </Page>
  );
};

export const SplashComponent: FC<Readonly<SplashComponentProps>> = ({
  eyebrow,
  heading,
  description,
  actions,
  visual,
  hideLogos,
  logoHeader = "Hightouch is used by",
  infoSection,
}) => {
  return (
    <>
      <Column align="center" justify="start" flex={1} minWidth={0} minH={0}>
        <Row
          position="relative"
          gap={{ base: 12, lg: 16 }}
          flexDir={{ base: "column", md: "row" }}
          justify="space-between"
          w="100%"
          align={{ base: "start", md: "center" }}
        >
          <Column flex={1} gap={6} maxW={{ base: "100%", md: "400px" }}>
            <Column gap={2}>
              <Row
                as={Text}
                align="center"
                gap={2}
                fontSize="sm"
                fontWeight="semibold"
              >
                {eyebrow}
              </Row>
              <Heading size="2xl" style={{ lineHeight: "1.2" }}>
                {heading}
              </Heading>
              <Text as="div" color="text.secondary" size="lg" mt={1}>
                {description}
              </Text>
            </Column>
            <ButtonGroup>{actions}</ButtonGroup>
          </Column>
          <Column
            flex={{ base: 0.75, md: 1 }}
            maxW={{ base: "480px", md: "534px" }}
          >
            {visual}
          </Column>
        </Row>
        {infoSection}
        {!hideLogos && (
          <Row position="relative" w="100%" mt={16} mb={24}>
            <Column gap={6} width="100%">
              <Text color="text.tertiary" size="sm" fontWeight="medium">
                {logoHeader}
              </Text>
              <SplashLogos />
            </Column>
          </Row>
        )}
      </Column>
    </>
  );
};
